var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLenovo = function SvgLenovo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E60012;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st0",
    d: "M214.64,225.82c-9.3,0-19.81,4.31-26.14,12.8l0,0l0,0v-11.45h-22.1v80.3h22.1v-45.68 c0-8.22,6.33-16.98,18.19-16.98c9.16,0,18.59,6.33,18.59,16.98v45.68h22.1v-49.72C247.24,239.29,234.04,225.82,214.64,225.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_27_",
    className: "st0",
    points: "403.94,227.17 384,281.87 364.06,227.17 338.86,227.17 371.87,307.47 396.13,307.47 429.14,227.17  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st0",
    d: "M100.51,251.42c3.77-4.99,9.7-7.95,16.98-7.95c7.95,0,14.01,4.58,17.11,11.18l-38.53,16.03 C94.99,262.33,97.15,256,100.51,251.42 M142.96,282.81c-9.3,6.87-14.55,8.49-23.04,8.49c-7.68,0-13.61-2.43-17.79-6.47l56.32-23.44 c-1.21-8.76-4.58-16.44-9.57-22.37c-7.41-8.62-18.32-13.2-31.66-13.2c-24.25,0-42.58,17.92-42.58,41.5c0,24.25,18.32,41.5,45,41.5 c14.96,0,30.18-7.01,37.32-15.36L142.96,282.81z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_31_",
    className: "st0",
    points: "72.49,287.26 22.37,287.26 22.37,203.18 0,203.18 0,307.47 72.49,307.47  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st0",
    d: "M468.75,244.68c-12.26,0-21.29,9.3-21.29,22.64c0,12.67,9.43,22.64,21.56,22.64 c12.26,0,21.29-9.57,21.29-22.64C490.31,254.65,480.74,244.68,468.75,244.68 M468.75,308.82c-24.12,0-42.98-17.92-42.98-41.5 c0-23.31,19-41.5,43.25-41.5c24.12,0,42.98,17.92,42.98,41.5C512,290.63,493,308.82,468.75,308.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st0",
    d: "M298.98,244.68c-12.26,0-21.29,9.3-21.29,22.64c0,12.67,9.43,22.64,21.56,22.64 c12.26,0,21.29-9.57,21.29-22.64C320.54,254.65,310.97,244.68,298.98,244.68 M298.98,308.82c-24.12,0-42.98-17.92-42.98-41.5 c0-23.31,19-41.5,43.25-41.5c24.12,0,42.98,17.92,42.98,41.5C342.23,290.63,323.23,308.82,298.98,308.82"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLenovo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lenovo.b95c87ad7dd37e982a2b174f097d84bc.svg";